// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__1hTQO","fillColor":"IconSuccess_fillColor__1euA9"};